export enum InventoryType {
  Publishers = 'publishers',
  Domains = 'domains',
}

export default InventoryType;
